module.exports = __webpack_public_path__ + "static/step3_203-a65bd1d77f700925f54901924420205a.png";